import { AssetSpinnerFullColor, styled } from '@lessonup/ui-components';
import React from 'react';

export interface SpinnerPinComponentProps {
  onClick?: () => void;
}

export const SpinnerPinComponent: React.FC<SpinnerPinComponentProps> = ({ onClick }) => {
  return <StyledSpinnerFullColor width="100%" height="100%" onClick={onClick} />;
};

const StyledSpinnerFullColor = styled(AssetSpinnerFullColor)<SpinnerPinComponentProps>`
  //There is currently a bug in Chromium that makes scaled SVG's appear pixelated at times According to this discussion: https://stackoverflow.com/a/45911373
  //A possible solution is to drop the opacity by 0,01 and trick Chromium into rendering it properly
  opacity: 0.99;
  cursor: ${(props) => (props.onClick !== undefined ? 'pointer' : 'inherit')};
`;
